// Search Bar custom functionality
if (window.location.href.includes("/blogs/news")) {
  var i, input, ul, li, searchValue, itemValue, cancelBtn;
  input = document.getElementById('srchInpt');
  li = document.querySelectorAll('#serchItems .category_article_item'); 
  ul = document.querySelector('#serchItems');
  // cancelBtn = document.querySelector(".faq_canCel"); 
  // var srchBtn = document.querySelector('#srchInpt_btn');
  
  input.addEventListener('keyup',function(){
    searchValue = input.value.trim().replace(/\s+/g, ' ').toUpperCase();
    for(i = 0; i < li.length; i++){
      itemValue = li[i].querySelector(".category_articleTitle").textContent;
      itemValue = itemValue.toUpperCase();
      
      if(itemValue.indexOf(searchValue) > -1){
        li[i].style.display = '';
        li[i].setAttribute("data-number", 1);
      } else {
        li[i].style.display = 'none';
        li[i].setAttribute("data-number", 0);
      }

      if(searchValue == '' || searchValue == ' '){
        // li[i].style.paddingTop = '72px';
        li[i].style.display = 'flex';
      }

      // if (searchValue == 0) {
      //   cancelBtn.style.display = "none";
      // } else {
      //   cancelBtn.style.display = "block";
      // }    
    }
    setTimeout(function () {
      let counterr = 0;
      document.querySelectorAll("[data-number='1']").forEach(function (lis) {
        counterr++;
      });
      if (counterr == 0) {
        console.log("Not found!");
      }
    }, 1000);

    // Get all div elements
    const divs = document.querySelectorAll('.category_article_item');
    let allHidden = true;
    // Iterate through each div and check if display is none
    divs.forEach(div => {
      const computedStyle = window.getComputedStyle(div);
      if (computedStyle.getPropertyValue('display') !== 'none') {
        allHidden = false;
        // If any div is not hidden, you can exit the loop early
        return;
      }
    });
    
    // If all divs are hidden, execute the if block, otherwise execute the else block
    var blgCrd = document.querySelector('.noResult_type');
    if (allHidden) {
      console.log("All divs have display: none.");
      blgCrd.classList.add("show_text");
    } else {
      blgCrd.classList.remove("show_text");
    }
  });

  // cancelBtn.addEventListener("click",() => {
  //   cancelBtn.style.display = 'none';
  // });
}
// Search Bar custom functionality